import { NgModule } from '@angular/core';
import { PathLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/AuthInterceptor';
import { GeneralSharedModule } from './renew/shared/GeneralSharedModule';
import { SiteExterneComponent } from './renew/site-externe/site-externe.component';
import { MyPrimeNgModule } from './renew/shared/MyPrimeNGModule';
import { VitrinenSharedModule } from './renew/vitrine-shared/vitrine-shared.module';

@NgModule({
    declarations: [AppComponent, SiteExterneComponent],
    imports: [CommonModule, AppRoutingModule, AppLayoutModule, GeneralSharedModule, MyPrimeNgModule, VitrinenSharedModule],
    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }

    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
